<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30"
      >
        <h3 class="mb-0">Item By Category</h3>
      </div>

      <ul class="ps-0 mb-0 list-unstyled">
        <li
          class="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom"
          v-for="item in listItemGroupCategory"
          :key="item.name"
        >
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 ms-2">
              <h6 class="fw-medium fs-16 mb-0">{{ item?.name }}</h6>
            </div>
          </div>
          <span class="fs-18 fw-medium text-secondary">{{ item?.total }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { useDashboardStore } from "@/stores/dashboard/general";
import { useCategoryStore } from "@/stores/master/category-store";
import { DashboardItemByCategory } from "@/types/interface/dashboard";
import { defineComponent, ref, onMounted } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "ItemByGroupCategory",
  setup() {
    const storeDashboard = useDashboardStore();
    const listItemGroupCategory = ref();
    const router = useRouter();
    const storeCategory = useCategoryStore();
    const dataCategory = ref([]);

    const loadItemByGroupCategory = async (query = "") => {
      if (router.currentRoute.value.params.code != undefined) {
        query = "?category_code=" + router.currentRoute.value.params.code;
      }

      const { success } = await storeDashboard.dispatchItemByGroupCategory(
        query
      );
      if (success) {
        listItemGroupCategory.value = storeDashboard.itemGroupCategory;
      }
    };

    onMounted(() => {
      loadItemByGroupCategory();
    });

    return {
      dataCategory,
      listItemGroupCategory,
      loadItemByGroupCategory,
    };
  },
});
</script>
